import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propBool, propFunc, propShape, } from '../../../../../helpers/custom-prop-types';
import FormUpdateMemo from '../Form/FormUpdateMemo';
const DetailMemo = ({ disabled, order, updateMemo }) => (_jsx("div", Object.assign({ className: 'detail-memo' }, { children: _jsx(FormUpdateMemo, { disabled: disabled, form: `FormUpdateMemo#${order.id}`, handleSubmit: updateMemo, initialValues: { memo: order.memo } }) })));
DetailMemo.propTypes = {
    disabled: propBool().isRequired,
    order: propShape().isRequired,
    updateMemo: propFunc().isRequired,
};
export default DetailMemo;
